import PropTypes from 'prop-types';
import { useMemo } from 'react';

// antd
import { Drawer as AntDrawer, Grid, theme as antTheme, ConfigProvider } from 'antd';

// project import
import DrawerHeader from './DrawerHeader';
import DrawerContent from './DrawerContent';
import Footer from './Footer';
import MiniDrawerStyled from './MiniDrawerStyled';
import { drawerWidth } from '@/config';
import { useSelector } from 'react-redux';
import { getSidebarColor } from '@/themes/antd-theme';
import { useTheme } from '@/App';

const { useBreakpoint } = Grid;

// ==============================|| MAIN LAYOUT - DRAWER ||============================== //

const MainDrawer = ({ open, handleDrawerToggle, window }) => {
  const { theme_color } = useSelector((state) => state.company_profile);
  const { isDark } = useTheme();
  const { token } = antTheme.useToken();
  const screens = useBreakpoint();
  const matchDownMD = !screens.lg;

  // Get sidebar color based on dark/light mode
  const sidebarBgColor = getSidebarColor(theme_color, isDark);

  // responsive drawer container
  const container = window !== undefined ? () => window().document.body : undefined;

  // header content
  const drawerContent = useMemo(() => <DrawerContent />, []);
  const drawerHeader = useMemo(() => <DrawerHeader open={open} />, [open]);
  const drawerFooter = useMemo(() => <Footer />, []);

  // Custom Ant Design theme for drawer
  const customTheme = {
    token: {
      colorTextBase: '#fff',
      colorText: '#fff',
      colorTextSecondary: '#E2E2E2',
      colorBgContainer: sidebarBgColor,
      colorBorder: '#fff',
    },
  };

  return (
    <ConfigProvider theme={customTheme}>
      <nav style={{ zIndex: 1300, width: 0 }} aria-label="mailbox folders">
        {!matchDownMD ? (
          <MiniDrawerStyled variant="permanent" open={open}>
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                height: '100vh', // 🔑 THIS is the fix
                backgroundColor: sidebarBgColor,
              }}
            >
              {/* Header */}
              {drawerHeader}

              {/* Scrollable content */}
              <div
                style={{
                  flex: 1,
                  overflowY: 'auto', // 🔑 content scrolls
                }}
              >
                {drawerContent}
              </div>

              {/* Footer pinned at bottom */}
              <div style={{ flexShrink: 0 }}>{drawerFooter}</div>
            </div>
          </MiniDrawerStyled>
        ) : (
          <AntDrawer
            getContainer={container}
            placement="left"
            open={open}
            onClose={handleDrawerToggle}
            width={drawerWidth}
            styles={{
              body: {
                padding: 0,
                backgroundColor: sidebarBgColor,
              },
            }}
            className="block lg:hidden"
          >
            {open && drawerHeader}
            {open && drawerContent}
          </AntDrawer>
        )}
      </nav>
    </ConfigProvider>
  );
};

MainDrawer.propTypes = {
  open: PropTypes.bool,
  handleDrawerToggle: PropTypes.func,
  window: PropTypes.object,
};

export default MainDrawer;
